import React from "react";
import { useTranslation } from "react-i18next";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import "../../styles/helpProfile.css";

export default function Helprgprofile() {
  const { t } = useTranslation("help");

  const rowsData = t("helprgprofile.table.rows", {
    returnObjects: true,
    defaultValue: {
      id: {
        column: "id",
        meaning: "Unique compliance case identifier.",
        guidance: "Use IDs that identify the regulation, policy family, or control area."
      },
      prompt: {
        column: "Prompt",
        meaning: "Compliance prompt or scenario.",
        guidance: "State the rule, user request, or policy-sensitive scenario to test."
      },
      category: {
        column: "Category",
        meaning: "Reporting category.",
        guidance: "Use policy_compliance_tests when the dataset is compliance-specific, or another supported category if the case is also a prompt-safety risk."
      },
      subCategory: {
        column: "Sub category",
        meaning: "Specific compliance or policy family.",
        guidance: "Use clear values such as policy_validation or compliance_overrides when matching the bundled help taxonomy."
      },
      severity: {
        column: "Severity",
        meaning: "Risk tier.",
        guidance: "Use high or critical for cases with regulatory, privacy, or safety consequence."
      },
      expectedResults: {
        column: "Expected results",
        meaning: "Regex pattern for expected violation signal.",
        guidance: "Match language that indicates non-compliance, unsafe advice, disclosure, refusal failure, or an incorrect policy outcome."
      }
    }
  });

  const tableRows = Array.isArray(rowsData)
    ? rowsData
    : Object.values(rowsData || {});

  return (
    <div className="theme-whbl">
      {/* Header */}

      <div className="container-fluid">
        <div className="row">
          <main
            style={{
              width: "97%",
              overflowX: "auto"
            }}
          >
            <div className="dashboard">
              {/* Page Header */}
              <div className="pm-header">
                <div className="pm-title-section">
                  <h1 className="pm-title">
                    {t(
                      "helprgprofile.title",
                      "Regulation Compliance Input Format"
                    )}
                  </h1>
                </div>
              </div>

              {/* Step 1 */}
              <div>
                <p>
                  {t(
                    "helprgprofile.description",
                    "The Regulation Compliance profile screen shows file selection rather than a separate schema table. For uploaded compliance datasets, use the same prompt-style CSV discipline unless the product build provides a regulation-specific template. The endpoint's request/response JSON mapping determines how each compliance prompt is sent and how the answer is read."
                  )}
                </p>

                <img
                  className="help-img"
                    src={t("helprgprofile.image")}
                  alt="Attack Surface Tests Status"
                />
                <br />
                <br />
<img
                  className="help-img"
                    src={t("helprgprofile.image2")}
                 
                />
               
                <br />
                <br />
<img
                  className="help-img"
                    src={t("helprgprofile.image3")}
              
                />

                <table className="dark-guide-table">
                  <thead>
                    <tr>
                      <th>
                        {t("helprgprofile.table.headers.column", "Column")}
                      </th>
                      <th>
                        {t("helprgprofile.table.headers.meaning", "Meaning")}
                      </th>
                      <th>
                        {t(
                          "helprgprofile.table.headers.guidance",
                          "Compliance guidance"
                        )}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {tableRows.map((row, index) => (
                      <tr key={index}>
                        <td>{row.column}</td>
                        <td>{row.meaning}</td>
                        <td>{row.guidance}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <style>{`
                  .dark-table-container {
                    width: 100%;
                    margin: 20px 0;
                    overflow-x: auto;
                    background: #111827;
                    padding: 0;
                    box-sizing: border-box;
                  }

                  .dark-guide-table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                    font-family: "Segoe UI", Arial, sans-serif;
                    font-size: 14px;
                    color: #e5e7eb;
                    background: #111827;
                    border: 1px solid #374151;
                  }

                  /* Header */
                  .dark-guide-table thead th {
                    background: #1f2937;
                    color: #60a5fa;
                    font-weight: 700;
                    text-align: left;
                    padding: 12px 14px;
                    border: 1px solid #4b5563;
                    vertical-align: middle;
                  }

                  /* Body cells */
                  .dark-guide-table tbody td {
                    background: #111827;
                    color: #e5e7eb;
                    padding: 12px 14px;
                    border: 1px solid #374151;
                    vertical-align: top;
                    line-height: 1.55;
                  }

                  /* Slight alternate row */
                  .dark-guide-table tbody tr:nth-child(even) td {
                    background: #172033;
                  }

                  /* Hover */
                  .dark-guide-table tbody tr:hover td {
                    background: #1e293b;
                  }

                  /* Column widths */
                  .dark-guide-table th:nth-child(1),
                  .dark-guide-table td:nth-child(1) {
                    width: 23%;
                  }

                  .dark-guide-table th:nth-child(2),
                  .dark-guide-table td:nth-child(2) {
                    width: 37%;
                  }

                  .dark-guide-table th:nth-child(3),
                  .dark-guide-table td:nth-child(3) {
                    width: 40%;
                  }

                  /* Mobile */
                  @media (max-width: 768px) {
                    .dark-table-container {
                      overflow-x: auto;
                    }

                    .dark-guide-table {
                      min-width: 750px;
                    }
                  }
                `}</style>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}